import Select from '../select/Select';
import FilterContainer from './FilterContainer';
import { useFilterContext } from './hooks';
import { SelectFilterConfig } from './types';

type SelectFilterProps = {
    title: string;
    id: string;
};

function SelectFilter({ title, id }: SelectFilterProps): JSX.Element {
    const filterInstance = useFilterContext();
    const filter = filterInstance.getFilterSection<SelectFilterConfig>(id);

    function onChange(values: { label: string; value: string | number }[]): void {
        filterInstance.updateSelectOption(
            id,
            values.map((v) => v.value.toString())
        );
    }

    return (
        <FilterContainer
            title={title}
            isOpen={filterInstance.getActiveFilterCount(id) > 0}
            activeFilterCount={filterInstance.getActiveFilterCount(id)}
        >
            <div className="p-2 z-0">
                <Select
                    isMulti={filter?.isMulti}
                    showMenuAsRelative
                    onChange={onChange}
                    size="small"
                    options={filter?.options?.map((o) => ({
                        value: o.value,
                        label: o.label,
                        isSelected: o.active,
                        decoration: o.decoration,
                    }))}
                />
            </div>
        </FilterContainer>
    );
}

export default SelectFilter;
